import { getIsCompleted, NAME as shopOrder, saveTempOrder } from '@/ducks/shopOrderReducer'
import { NAME as shopProgress } from '@/ducks/shopProgressReducer'
import { SEC } from '@/util/formatters/dates'

const ignoreActions = [
  `${shopOrder}/setTempOrderId`,
  `${shopOrder}/setShopOrderState`,
  `${shopProgress}/setShopOrderProgressState`,
]
// @ts-ignore
const isRelevantType = type =>
  [shopProgress, shopOrder].includes(type.split('/')[0]) && !ignoreActions.includes(type)

const SAVE_DELAY = 2 * SEC

let timeOut = 0

// @ts-ignore
export const shopTempMiddleware = store => next => action => {
  const { type } = action
  const { dispatch, getState } = store

  if (isRelevantType(type) && !getIsCompleted(getState())) {
    clearTimeout(timeOut)
    // @ts-ignore
    timeOut = setTimeout(async () => {
      dispatch(saveTempOrder())
    }, SAVE_DELAY)
  }

  return next(action)
}
